export const LOGOUT = 'LOGOUT';
export const SET_MULTI_SESSION = 'SET_MULTI_SESSION';
